/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import DIYGatewayManagement from "../DIYGatewayManagement";

/**
 * This class is the base for all the possible states possible
 * in the DIY gateway management application.
 * Each of the states needs to extend this and provide an implementation
 * for teh JSX.Element that will be returned
 */
export abstract class AbstractWizardState {

  /**
   * Constructor injection of page
   * @param {DIYGatewayManagement} page
   */
  constructor(page: DIYGatewayManagement) {
    this.page = page;
  }

  /**
   * Returns the content for the particular page/wizard screen
   * @returns {JSX.Element}
   */
  public abstract getContent(): JSX.Element;

  /**
   * The root state manager instance.
   * The wizard state subclasses must manipulate the state
   * of the instance in order to affect a state transition
   */
  protected page: DIYGatewayManagement;
}
